module.exports = __webpack_public_path__ + "img/map_rows.a48da78a.jpg";